import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { ExternalLink } from 'lucide-react';

const Portfolio = () => {
  const { t } = useLanguage();

  return (
    <section id="portfolio" className="relative py-20 lg:py-28 bg-white">
      {/* Background Accent */}
      <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-gradient-to-br from-[#BBEFF3]/30 to-transparent rounded-full blur-3xl" />
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0B2E4B] mb-4">
            {t.portfolio.title}
          </h2>
          <p className="text-lg text-[#0B2E4B]/70 max-w-2xl mx-auto">
            {t.portfolio.subtitle}
          </p>
        </div>

        {/* Portfolio Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {t.portfolio.items.map((project) => (
            <a
              key={project.id}
              href={project.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative overflow-hidden bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-400 border border-gray-100"
            >
              {/* Project Image */}
              <div className="aspect-video overflow-hidden bg-gradient-to-br from-[#0B2E4B] to-[#0d3a5c]">
                <img 
                  src={project.image} 
                  alt={project.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                
                {/* Hover Overlay */}
                <div className="absolute inset-0 bg-[#0B2E4B]/60 opacity-0 group-hover:opacity-100 transition-opacity duration-400 flex items-center justify-center">
                  <div className="flex items-center gap-2 text-white font-semibold bg-[#28BBC5] px-6 py-3 rounded-lg">
                    <span>{t.portfolio.viewProject}</span>
                    <ExternalLink className="w-5 h-5" />
                  </div>
                </div>
              </div>

              {/* Project Info */}
              <div className="p-6">
                <span className="inline-block text-xs text-white font-semibold uppercase tracking-wider bg-[#28BBC5] px-3 py-1 rounded-full">
                  {project.category}
                </span>
                <h3 className="text-xl font-bold text-[#0B2E4B] mt-3 mb-2 group-hover:text-[#28BBC5] transition-colors duration-300">
                  {project.name}
                </h3>
                <p className="text-sm text-[#0B2E4B]/60 leading-relaxed">
                  {project.description}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
